import React from 'react';
import { Link } from 'react-router-dom';
import cx from 'classnames';

import { MDText } from 'i18n-react';

import { Content } from '@motorway/motorway-storybook-cra';
import { Button } from '@motorway/mw-highway-code';

import { HOMEPAGE_GA_TAGS, HOMEPAGE_SECTIONS } from 'Utilities/analytics/analyticsHomePage';
import { SELL_MY_CAR_PATH } from 'Utilities/wordpress';

import { useBreakpoint } from '../../../../../components/misc/Breakpoints/Breakpoints';
import { usePageRefEvents } from '../../../common/Hooks/usePageRefEvents';
import LocalTexts from '../../HomepageTexts.json';

import styles from './Claim.scss';

const LocalT = new MDText(LocalTexts);

const t = (key: string) => LocalT.translate(key) as string;

const callToActionProps = {
  ctaButtonLabel: t('claim.cta.buttonLabel'),
  ctaHref: SELL_MY_CAR_PATH,
  ctaTagline: LocalT.translate('claim.cta.tagline', { asterisk: (<sup className={styles.asterisk}>**</sup>) }),
  ctaTitle: t('claim.cta.title'),
  onClick: () => HOMEPAGE_GA_TAGS.SECTION_CTA_CLICKED(HOMEPAGE_SECTIONS.CLAIM),
  showOnMobile: true,
};

type Props = {
  readonly className?: string;
}

export const Claim = ({ className }: Props) => {
  const onRefTrigger = () =>
    HOMEPAGE_GA_TAGS.SECTION_LOADED(HOMEPAGE_SECTIONS.CLAIM);
  const { setRef } = usePageRefEvents({ onRefTrigger });

  const breakpoints = useBreakpoint();
  const isTabletMobile = !breakpoints?.maxWidth?.breakpointTabletMobile;
  return (
    <div
      ref={(ref) => setRef(ref)}
      className={cx(className)}>
      <Content className={styles.component}>
        <div className={styles.ctaBlock}>
          <div className={styles.tagline}>
            <h3 className={styles.ctaTaglineTitle} data-cy="claimSection">{callToActionProps.ctaTitle}</h3>
            <p className={styles.ctaTagline}>{callToActionProps.ctaTagline}</p>
          </div>
          <div className={styles.cta}>
            <Button as={Link} fullWidth={true} icon='chevron' label={callToActionProps.ctaButtonLabel} onClick={callToActionProps.onClick} size={isTabletMobile ? 'large' : 'medium'} to={callToActionProps.ctaHref} />
          </div>
        </div>
      </Content>
    </div>

  );
};
